import type { DocumentModifiedAtTableCellFragment } from "../client/generated";
import { DocumentDateTableCell } from "./DocumentDateTableCell";

type Props = {
  fragment: DocumentModifiedAtTableCellFragment;
};

export function DocumentModifiedAtTableCell({ fragment }: Props) {
  return <DocumentDateTableCell date={fragment.lastModifiedAt} />;
}
